import React from 'react'
import './ContactUs.css'

function ContactUs() {
    return (
        <div className="ContactUs">
            <form className="contactForm" action="">
                <h1 className="sectionArea">Contact Us</h1>
                <div className="formContorll">
                    <label htmlFor="">Email address</label> <br/>
                    <input type="email" placeholder="name@example.com" />
                </div>
                <div className="formContorll">
                    <label htmlFor="">What's this about?</label> <br/>
                    <select name="" id="">
                        <option value="">List my contract/store</option>
                        <option value="">Technical Support</option>
                        <option value="">Business Enquiry</option>
                        <option value="">Media</option>
                        <option value="">Pro Services</option>
                        <option value="">Collaboration</option>
                    </select>
                </div>
                <div className="formContorll">
                    <label htmlFor="">Your message</label> <br/>
                    <textarea name="" id="" cols="30" rows="10" ></textarea>
                </div>
                <button className="btnSubmit" type="submit" >Message us</button>
            </form>
        </div>
    )
}

export default ContactUs
